import { render, staticRenderFns } from "./addBankAccount.vue?vue&type=template&id=37c0aa65&lang=pug"
import script from "./addBankAccount.vue?vue&type=script&lang=js"
export * from "./addBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports